(function ($, SCS, debug) {
	'use strict';

	var zeroFill = require('lib/util/helpers').zeroFill;
	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	/**
	 * Static helper
	 */
	SCS.TV.Helper = SCS.TV.Helper || {};

	// returns first object in an array that has field "Kind" with the value of parameter kind
	SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape = function (array, kind, role, shape, count) {
		if (!count) {
			count = 1;
		}
		if (!array || array.length < 1) {
			return null;
		}
		var collected = [];
		for (var i = 0; i < array.length; i++) {
			if ((!shape && !role && array[i].Kind === kind) ||
				(!shape && array[i].Kind === kind && array[i].Role === role) ||
				(array[i].Kind === kind && array[i].Role === role && array[i].Shape === shape)) {
				collected.push(array[i]);
				if (collected.length >= count) {
					break;
				}
			}
		}
		if (collected.length === 0) {
			return null;
		}
		else if (count > 1) {
			return collected;
		}
		else {
			return collected[0];
		}

	};

	// returns minimum available image width that is larger than given width (if possible)
	SCS.TV.Helper.getBestImageWidth = function (neededWidth) {
		neededWidth = neededWidth || 0;
		var availableWidth = SCS.Const.SNOOPY_IMAGE_WIDTHS.slice(-1)[0]; // max width
		for (var i = 0; i < SCS.Const.SNOOPY_IMAGE_WIDTHS.length; i++) {
			if (SCS.Const.SNOOPY_IMAGE_WIDTHS[i] >= neededWidth) {
				availableWidth = SCS.Const.SNOOPY_IMAGE_WIDTHS[i];
				break;
			}
		}
		return availableWidth;
	};

	// returns array without entries that had the same title as another entry
	SCS.TV.Helper.removeDuplicateTitles = function (broadcasts) {
		var filteredBroadcasts = [],
			found = false;

		for (var i = 0; i < broadcasts.length; i++) {
			found = false;
			for (var j = 0; j < filteredBroadcasts.length; j++) {
				if (filteredBroadcasts[j].title === broadcasts[i].title) {
					found = true;
					break;
				}
			}
			if (!found) {
				filteredBroadcasts.push(broadcasts[i]);
			}
		}
		return filteredBroadcasts;
	};

	// preformats date so IE8 can convert it to date object
	SCS.TV.Helper.readDateIE8 = function (dateStr) {
		if (dateStr && typeof dateStr.getMonth === 'function') {
			return dateStr; // is already a date
		}
		dateStr = dateStr.replace(/-/g, '/').replace(/T/, ' ');
		return new Date(dateStr);
	};

	// checks if @str might be a broadcast-id
	SCS.TV.Helper.isPossibleBroadcastId = function(str) {
		return (str && str.length === 16);
	};

	// checks if @str might be a sportevent-id
	SCS.TV.Helper.isPossibleSportEventId = function(str) {
		return (str && str.length === 36);
	};

	// takes availabilities and selects the cheapest currently available one
	SCS.TV.Helper.selectCheapestCurrentAvailability = function(availabilities) {
		if (!availabilities || availabilities.length < 1) {
			return null;
		}

		var currentlySelected = null,
			currentStart = null,
			currentEnd = null,
			currentPrice = null,
			now = new Date();

		for (var i = 0; i < availabilities.length; i++) {
			if (availabilities[i].AvailabilityStart && availabilities[i].AvailabilityEnd && availabilities[i].Price) {
				currentStart = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(availabilities[i].AvailabilityStart) : new Date(availabilities[i].AvailabilityStart);
				currentEnd = SCS.Const.SNOOPY_IS_OLD_IE ? SCS.TV.Helper.readDateIE8(availabilities[i].AvailabilityEnd) : new Date(availabilities[i].AvailabilityEnd);
				currentPrice = parseFloat(availabilities[i].Price);
				if (currentStart.valueOf() < now.valueOf() && currentEnd.valueOf() > now.valueOf() && (currentlySelected === null || currentlySelected.Price > currentPrice)) {
					currentlySelected = availabilities[i];
				}
			}
		}

		return currentlySelected;
	};

	// parses a duration string in the form hh:mm and return a number of minutes
	SCS.TV.Helper.getMinutesFromDurationString = function(durationStr) {
		var parts = durationStr.split('.'),
			minutes = 0,
			timeParts = null;

        if (parts.length > 1) {
            minutes += 24*60*parseInt(parts[0]);
            timeParts = parts[1].split(':');
        }
        else {
            timeParts = parts[0].split(':');
        }

        minutes += 60*parseInt(timeParts[0]);
        minutes += parseInt(timeParts[1]);

        return minutes;
	};

	// checks if a date is today
	SCS.TV.Helper.isToday = function(date) {
		return date && date.toDateString() === (new Date()).toDateString();
	};

	// checks if a date is tomorrow
	SCS.TV.Helper.isTomorrow = function(date) {
		return date && date.toDateString() === new Date((new Date()).getTime() + 24 * 60 * 60 * 1000).toDateString();
	};

	// returns formatted date to be used for the creation of ICS files - also calculates the time to UTC
	SCS.TV.Helper.getICSDate = function(date) {
		var dateStr = '',
			d = date || new Date();

		dateStr += d.getUTCFullYear();
		dateStr += zeroFill(d.getUTCMonth() + 1);
		dateStr += zeroFill(d.getUTCDate());
		dateStr += 'T';
		dateStr += zeroFill(d.getUTCHours());
		dateStr += zeroFill(d.getUTCMinutes());
		dateStr += zeroFill(d.getUTCSeconds());
		dateStr += 'Z';

		return dateStr;
	};

	/**
	 * Sorts objects in array @toOrder in the same order as the object-value @key is ordered in rightOrder
	 */
	SCS.TV.Helper.orderByArrayOrder = function(rightOrder, toOrder, key) {
		var newOrder = [];
		for (var i = 0; i < rightOrder.length; i++) {
			for (var j = 0; j < toOrder.length; j++) {
				if (rightOrder[i] === toOrder[j][key]) {
					newOrder.push(toOrder[j]);
					break;
				}
			}
		}
		return newOrder;
	};



}(window.jQuery, window.SCS = window.SCS || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Helper.js
// module id = 90
// module chunks = 0